var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfluxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 14,
    viewBox: "0 0 42 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0800781 13.5802H1.99512V4.86963H0.0800781V13.5802Z",
    fill: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0800781 2.3658H1.99512V0.865234H0.0800781V2.3658Z",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9254 13.5802H21.8404V0.865234H19.9254V13.5802Z",
    fill: "#1D1D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0401 9.32865C12.0204 8.03493 12.0796 6.574 11.1587 5.54944C10.8781 5.23749 10.5224 5.00403 10.1251 4.86955C8.01504 4.15535 6.02172 5.01625 5.16693 6.19422V4.86955H3.36823V13.5801H5.16693V7.78352C5.45994 7.33098 5.96611 6.76842 6.87315 6.3149C7.78197 5.86059 8.98045 5.84521 9.71831 6.6296C10.0409 6.97251 10.1955 7.40158 10.2063 7.86575C10.2154 8.25341 10.1923 13.6341 10.2063 13.6341H12.0401C12.0764 13.6326 12.0457 9.69817 12.0401 9.32865Z",
    fill: "#1D1D1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6772 4.86755V10.7201C29.3842 11.1727 28.878 11.7352 27.971 12.1888C27.0622 12.6431 25.8637 12.6585 25.1258 11.8741C24.8034 11.5312 24.6486 11.1021 24.6378 10.6379C24.6287 10.2503 24.6518 4.86953 24.6378 4.86953H22.7567C22.7204 4.8711 22.751 8.8055 22.7567 9.17502C22.7764 10.4687 22.7646 11.9295 23.6854 12.9542C23.966 13.2662 24.3217 13.4996 24.719 13.6341C26.8291 14.3483 28.8224 13.4874 29.6772 12.3094V13.6341H31.4759V4.86755H29.6772Z",
    fill: "#1D1D1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5119 1.55989C17.7974 1.54944 18.0845 1.58691 18.3604 1.65986C18.386 1.66657 18.7011 1.74229 18.7011 1.77324V0.292203C15.5619 -0.43698 14.4147 1.13536 14.0959 1.88722C13.7768 2.63908 13.8788 4.30251 13.8788 4.30251V4.84398H12.4399V6.27316H13.8788V13.5802H15.7938V6.27316H18.7011V4.84398H15.7938V4.09744C15.8059 3.46803 15.7215 2.7566 16.1281 2.22558C16.4534 1.80046 16.9858 1.57922 17.5119 1.55989Z",
    fill: "#1D1D1D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5641 13.6056L38.4948 9.77295L37.2902 11.1668L39.2937 13.6056H41.5641Z",
    fill: "#1D1D1D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3344 4.80792L35.8131 9.27018L32.1114 13.6056H34.1144L37.8382 9.23409L34.3163 4.80792H32.3344Z",
    fill: "#1D1D1D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4132 4.80792L37.329 7.36302L38.4823 8.82395L41.6788 4.80792H39.4132Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluxLogo);
export default __webpack_public_path__ + "static/media/influx-logo.dfa1cd956bbdb790831f20b998e064d7.svg";
export { ForwardRef as ReactComponent };